// extracted by mini-css-extract-plugin
export default {"clients":"clients_clients__wvP9E","line":"clients_line__RniAK","subtitle":"clients_subtitle__3v4A-","disclaimer":"clients_disclaimer__tMON4","column":"clients_column__-ymyz"};